import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import serviceCoreService from '../../service/serviceCore.service';
import { MaterialPolicyLabels } from '../../config/service';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';
const ServiceReports = ({ serviceState }) => {
  const {
    refetchTable,
    setRefetchTable,
    viewField,
    setSelectedValues,
    operatorsDisabled,
    rowSelectionModel,
    setRowSelectionModel,
    autocompleteOptions,
    params,
  } = serviceState;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const [initialState, setInitialState] = useState({
    filter: {
      filterModel: {
        items: [],
        logicOperator: 'and',
      },
    },
    sorting: {
      sortModel: [{ field: 'workingNumber', sort: 'desc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  });

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = async (gridState) => {
    serviceCoreService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'workingNumber',
      type: 'string',
      headerName: 'Munkaszám',
    },
    {
      field: 'projectId',
      type: 'string',
      headerName: 'Projekt',
      renderCell: (data) => {
        return data.row.project?.projectName;
      },
    },
    {
      field: 'projectOrderNumber',
      headerName: getProjectOrderNumberName(params),
      type: 'string',
      sortable: false,
      renderCell: (data) => {
        return data.row.project?.orderNumber;
      },
    },
    {
      field: 'serviceTaskTypeId',
      type: 'singleSelect',
      headerName: 'Szerviz típus',
      renderCell: (data) => {
        return data.row.serviceTaskType?.name;
      },
      valueOptions: autocompleteOptions.serviceTaskType,
    },
    {
      field: 'costCenterId',
      type: 'singleSelect',
      headerName: 'Költséghely',
      renderCell: (data) => {
        return data.row.costCenter?.name;
      },
      valueOptions: autocompleteOptions.costCenter,
    },
    {
      field: 'serviceStatusId',
      type: 'singleSelect',
      headerName: 'Státusz',
      renderCell: (data) => {
        return data.row.serviceStatus?.name;
      },
      valueOptions: autocompleteOptions.serviceStatus,
    },
    {
      field: 'priorityId',
      type: 'singleSelect',
      headerName: 'Prioritás',
      renderCell: (data) => {
        return data.row.priority?.name;
      },
      valueOptions: autocompleteOptions.priority,
    },
    {
      field: 'userId',
      type: 'singleSelect',
      headerName: 'Tulajdonos',
      renderCell: (data) => {
        return data.row.user?.nickName;
      },
      valueOptions: autocompleteOptions.user,
    },
    {
      field: 'startDate',
      type: 'date',
      headerName: 'Kezdő dátum',
      valueGetter: (_data, row) => {
        return new Date(row.startDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.startDate).format('YYYY.MM.DD.');
      },
    },
    {
      field: 'endDate',
      type: 'date',
      headerName: 'Befejező dátum',
      valueGetter: (_data, row) => {
        return new Date(row.endDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.endDate).format('YYYY.MM.DD.');
      },
    },
    {
      field: 'dueDate',
      type: 'date',
      headerName: 'Határidő',
      valueGetter: (_data, row) => {
        return new Date(row.dueDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.dueDate).format('YYYY.MM.DD.');
      },
    },
    {
      field: 'materialPolicy',
      type: 'singleSelect',
      headerName: 'Anyagkezelés',
      renderCell: (data) => {
        return MaterialPolicyLabels.find((label) => label.value === data.row.materialPolicy)?.label ?? '';
      },
      valueOptions: MaterialPolicyLabels,
    },
    { field: 'reference', type: 'string', headerName: 'Referencia' },
    { field: 'description', type: 'string', headerName: 'Leírás' },
  ]);

  return (
    <>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.Service}
        datagridInitialState={initialState}
        dataLoader={getList}
        rows={reports.rows}
        refetch={{ refetchTable, setRefetchTable }}
        rowCount={reports.rowCount}
        columns={[...columns]}
        onRowClick={(rowData) => {
          if (!viewField) return;
          setSelectedValues(rowData.row);
        }}
        paginationAndfilterMode={'server'}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        disableRowSelectionOnClick={!viewField}
      />
    </>
  );
};

export default ServiceReports;
